import { toast } from "react-toastify";
import { reportAsyncError } from "../../../../error-reporter";
import apiClient from "../../../apis/tenant-management/tenant-management-client";
import { CloudGovApiError } from "../../../domain/api-error";
import { BaseApplicationService } from "../../../domain/base/base-application-service";
import {
  availableIdleSessionTimeouts,
  OrganizationSessionSetting,
  OrganizationSessionSettingEntity,
} from "../../../domain/organization/org-session-setting";

export type OrgSessionSettingServiceProps = {
  isLoading: boolean;
  availableIdleSessionTimeouts: OrganizationSessionSettingEntity[];
  currentIdleSessionTimeout: OrganizationSessionSettingEntity | null;
  fetchOrgIdleSessionTimeoutSetting: typeof OrgSessionSettingService.prototype.fetchOrgIdleSessionTimeoutSetting;
  updateOrgIdleSessionTimeoutSetting: typeof OrgSessionSettingService.prototype.updateOrgIdleSessionTimeoutSetting;
};

export class OrgSessionSettingService extends BaseApplicationService<OrgSessionSettingServiceProps> {
  state = {
    isLoading: false,
    availableIdleSessionTimeouts: availableIdleSessionTimeouts,
    currentIdleSessionTimeout: null,
    fetchOrgIdleSessionTimeoutSetting:
      this.fetchOrgIdleSessionTimeoutSetting.bind(this),
    updateOrgIdleSessionTimeoutSetting:
      this.updateOrgIdleSessionTimeoutSetting.bind(this),
  };

  private setIsLoading(isLoading: boolean) {
    this.setState({ isLoading: isLoading });
  }

  async fetchOrgIdleSessionTimeoutSetting(orgID: string) {
    this.setIsLoading(true);
    try {
      const { data } = await apiClient.fetchOrgIdleSessionTimeoutSetting(orgID);
      const sessionSetting = OrganizationSessionSettingEntity.fromJSON(data);

      console.log(sessionSetting.idleSessionTimeoutSecond);

      const found = availableIdleSessionTimeouts.find(
        (v) =>
          v.idleSessionTimeoutSecondValue ===
          sessionSetting.idleSessionTimeoutSecondValue,
      );

      this.setState({
        currentIdleSessionTimeout: found,
      });
    } catch (e) {
      reportAsyncError(e);
    } finally {
      this.setIsLoading(false);
    }
  }

  async updateOrgIdleSessionTimeoutSetting(
    orgID: string,
    idleSessionTimeout: OrganizationSessionSetting,
  ) {
    this.setIsLoading(true);
    try {
      await apiClient.updateOrgIdleSessionTimeoutSetting(
        orgID,
        idleSessionTimeout,
      );

      toast.success("セッション有効期間を更新しました。");
    } catch (e) {
      if (CloudGovApiError.isBadRequest(e)) {
        toast.error("更新に失敗しました。入力内容が間違っています。");
      }
      reportAsyncError(e);
    } finally {
      this.setIsLoading(false);
    }
  }
}
